import React from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import { Wrapper } from 'components/shared';
import media from 'styled-media-query';
import { APP_NAME } from 'constants/views';
import Blockquote from './Blockquote';
import susanAvatar from './SusanAvatar.png';
import folagiAvatar from './FolagiAvatar.png';
import NorthCarolinaAvatar from './NorthCarolinaAvatar.png';
import GaryAAvatar from './GaryAAvatar.png';
import JodyStephenAvatar from './JodyStephenAvatar.png';
import { Icon } from 'components/shared';

import './index.css';

function Testimonials() {
  return (
    <TestimonialsContainer>
      <Wrapper>
        <Title>What our clients say</Title>
        <Subtitle>Don’t just take our word for it - hear from our satisfied clients </Subtitle>
        <StyledTestimonials>
          <Slider
            dots
            arrows={false}
            infinite={false}
            slidesToShow={2}
            slidesToScroll={2}
            navs={false}
            responsive={[
              {
                breakpoint: 900,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
            ]}
          >
            <div>
              <TestimonialContainer>
                <StyledQuote><Icon width='1.875' icon="quoteLeft" /></StyledQuote>
                <QuoteText>Before I found {APP_NAME}, I contacted up to 50 lenders and was very disappointing with their results
                  and legitimacy.Working with {APP_NAME} has been great; it's been more than a year and I have
                  successfully referred about a dozen clients.
                </QuoteText>
                <Blockquote avatar={susanAvatar} cite="Susan E" fromThe="Colorado Broker/Investors" />
              </TestimonialContainer>
            </div>
            <div>
              <TestimonialContainer>
                <StyledQuote><Icon width='1.875' icon="quoteLeft" /></StyledQuote>
                <QuoteText> Having the entire process online is very convenient and user friendly. I would definitely recommend{' '}
                  {APP_NAME}. The knowledge base of the loan specialist, his professional guidance on the project from
                  pre-approval to closing went very smoothly...
                </QuoteText>
                <Blockquote avatar={folagiAvatar} cite="Folagi" fromThe="New Jersey Investor" />
              </TestimonialContainer>
            </div>
            <div>
              <TestimonialContainer>
                <StyledQuote><Icon width='1.875' icon="quoteLeft" /></StyledQuote>
                <QuoteText>The one-on conversations with my loan specialist versus a number cruncher who has no true insights of
                  what a investor really needs and is going through, made a huge difference.Spot-on appraisals and no
                  low ball BPOs allowed for smooth closing.
                </QuoteText>
                <Blockquote avatar={NorthCarolinaAvatar} cite="North Carolina Investors " />
              </TestimonialContainer>
            </div>
            <div>
              <TestimonialContainer>
                <StyledQuote><Icon width='1.875' icon="quoteLeft" /></StyledQuote>
                <QuoteText>“Four closings in less than a month. I’m delighted with my lender”
                </QuoteText>
                <Blockquote avatar={GaryAAvatar} cite="Gary A." fromThe="Illinois" />
              </TestimonialContainer>
            </div>
            <div>
              <TestimonialContainer>
                <StyledQuote><Icon width='1.875' icon="quoteLeft" /></StyledQuote>
                <QuoteText>“We felt that they were real knowledgeable people, it wasn’t just an online lending portal. We closed
                  two weeks earlier than our contract. We anticipate doing 7-10 fix-n-flips a year with {APP_NAME}.”
                </QuoteText>
                <Blockquote avatar={JodyStephenAvatar} cite="Jody and Stephen" fromThe="Indiana Investors" />
              </TestimonialContainer>
            </div>
          </Slider>
        </StyledTestimonials>
      </Wrapper>
    </TestimonialsContainer>
  );
}

const TestimonialsContainer = styled.section`
  padding: 31px 0 40px;
`;

const StyledTestimonials = styled.div`
  margin: 0 auto;
  padding: 40px 0;
  height: 110%;
`;
const QuoteText = styled.p`
  text-align: left;
  font-size: var(--font-size-s);
  line-height: var(--line-height-list);
  min-height: 200px;
  width: 100%;
  font-style: italic;
  color: var(--color-primary);
  box-sizing: border-box;
  margin-bottom: 12px;
  position: relative;
  top: -2em;
`;
const StyledQuote = styled.div`
  background: var(--color-primary);
  top: -40px;
  left: -190px;
  @media (max-width: 768px) {
    left: -100px;
  }
  border-radius: 100%;
  color: #fff;
  padding: 10px;
  position: relative;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;


const TestimonialContainer = styled.section`
  position: relative;
  max-width: 430px;
  padding: 20px 20px 0 20px;
  text-align: center;
  background-color: white;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  ${media.lessThan('1024px')`
    max-width: 330px;
  `};
`;

const Title = styled.span`
  margin-bottom: 30px;
  display: block;
  text-align: center;
  font-size: var(--font-size-l);
  font-weight: 700;
  color: var(--color-primary);
`;
const Subtitle = styled.span`
  display: block;
  text-align: center;
  font-size: var(--font-size-s);
  font-weight: 300;
  color: var(--color-secondary-text);
`;

export default Testimonials;
